import React from 'react';
import CardHeader from '../../card-header';
import LastUpdated from '../../last-updated';
import { nodeType } from '../../../utils/constants';
import { EventIcon } from '../../icon/icon';
import './event-card.css';

const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
};

const formatDateRange = (startDate, endDate) => {
  const start = formatDate(startDate);
  const end = formatDate(endDate);
  if (!start && !end) return '';
  if (start === end || !end) return start;
  return `${start} - ${end}`;
};

const isPastEvent = (endDate) => {
  if (!endDate) return false;
  try {
    return new Date(endDate) < new Date();
  } catch {
    return false;
  }
};

export const EventCard = ({
  properties,
  openFlagModal,
  shortestPath,
  closeAnnotation,
  moreInformation,
}) => {
  const {
    name,
    eventType,
    status,
    venue,
    location,
    affiliationUnit,
    startDate,
    endDate,
    description,
    tedUrl,
    ingestionDateUtc,
  } = properties;

  const dateRange = formatDateRange(startDate, endDate);
  const isPast = isPastEvent(endDate);

  return (
    <div className="event-card">
      <CardHeader
        value={nodeType.Event}
        nodeId={properties.nodeKey}
        icon={<EventIcon />}
        isContextNode={properties.isContextNode}
        name={name || 'Unknown Event'}
      />

      <div className="event-card__content">
        {eventType && (
          <div className="event-card__type-badge">
            {eventType}
          </div>
        )}

        {isPast && (
          <div className="event-card__past-badge">
            Past Event
          </div>
        )}

        {dateRange && (
          <div className="event-card__row">
            <span className="event-card__label">Date:</span>
            <span className="event-card__value">{dateRange}</span>
          </div>
        )}

        {venue && (
          <div className="event-card__row">
            <span className="event-card__label">Venue:</span>
            <span className="event-card__value">{venue}</span>
          </div>
        )}

        {location && (
          <div className="event-card__row">
            <span className="event-card__label">Location:</span>
            <span className="event-card__value">{location}</span>
          </div>
        )}

        {affiliationUnit && (
          <div className="event-card__row">
            <span className="event-card__label">Unit:</span>
            <span className="event-card__value">{affiliationUnit}</span>
          </div>
        )}

        {description && (
          <div className="event-card__description">
            {description.length > 150
              ? `${description.substring(0, 150)}...`
              : description}
          </div>
        )}

        {status && status !== 'Active' && (
          <div className="event-card__status">
            Status: {status}
          </div>
        )}
      </div>

      <div className="event-card__last-updated">
        <LastUpdated
          ingestionDateUtc={ingestionDateUtc}
          isContextNode={properties.isContextNode}
          nodeKey={properties.nodeKey}
        />
      </div>

      {/* TED link intentionally hidden */}
    </div>
  );
};

export default EventCard;
